import { Component } from '@angular/core';

import { ParticipantPriceType } from '@cds/betting-offer';
import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { WinGameFixture } from '@frontend/sports/racing/feature/models';
import { IntlService } from '@frontend/vanilla/core';

import { HorsesFixtureParticipantHelper } from '../../../horse-racing-shared/services/horses-fixture-participant-helper.service';
import { HorsesFixturePricingHelper } from '../../../horse-racing-shared/services/horses-fixture-pricing-helper.service';
import { HorsesFixtureSortingHelper } from '../../../horse-racing-shared/services/horses-fixture-sorting-helper.service';
import { RacePreviewComponent } from './race-preview.component';

@Component({
    selector: 'ms-derived-race-preview',
    templateUrl: 'race-preview.component.html',
    standalone: false,
})
export class DerivedRacePreviewComponent extends RacePreviewComponent {
    constructor(
        public override siteCore: Sitecore,
        horsesFixturePricingHelper: HorsesFixturePricingHelper,
        horsesFixtureSortingHelper: HorsesFixtureSortingHelper,
        participantHelper: HorsesFixtureParticipantHelper,
        intlService: IntlService,
    ) {
        super(siteCore, horsesFixturePricingHelper, horsesFixtureSortingHelper, participantHelper, intlService);
    }

    override setViewModel(fixture: WinGameFixture): void {
        this.isOptionBet = fixture.isOptionBet;

        if (fixture.participants.length === 0) {
            return;
        }
        const runners = this.participantHelper.getParticipants(fixture.participants);

        if (fixture.optionGroups && fixture.optionGroups.length) {
            this.participantOptionGroups = this.participantHelper.getParticipantOptionGroups(fixture.optionGroups[0], runners);
            const options = this.horsesFixturePricingHelper.getOptionPrices(fixture, fixture.optionGroups[0], ParticipantPriceType.Fixed);
            const sortedParticipants = this.horsesFixtureSortingHelper.sortOptionParticipantsByWinMarket(runners, options);
            const topThreeRunners = sortedParticipants.slice(0, 3);
            this.vm = {
                race: fixture,
                runners: topThreeRunners.map((r) => {
                    const priceType = fixture.optionGroups[0].isWinPriceAvailable ? ParticipantPriceType.Fixed : ParticipantPriceType.StartingPrice;

                    const eventOption = this.horsesFixturePricingHelper.getParticipantOptions(r.id, this.participantOptionGroups, priceType);

                    return {
                        ...r,
                        option: eventOption,
                        priceHistory: this.horsesFixturePricingHelper.getV3PriceHistory(eventOption),
                        attributes: this.participantHelper.getHorseRaceInfo(r),
                        isOptionActive: false,
                    };
                }),
            };

            this.setTrackingOptions(fixture);
        }
    }
}
